import { useState } from "react";

export const useNewsTooltip = (isTapToOpen: boolean) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const close = () => setOpenKey(null);

  const getTooltipProps = (key: string) =>
    isTapToOpen
      ? {
          open: openKey === key,
          onClose: close,
          disableHoverListener: true,
          disableTouchListener: true,
        }
      : {};

  const getBadgeProps = (key: string) =>
    isTapToOpen
      ? {
          onClick: () =>
            setOpenKey((current) => (current === key ? null : key)),
        }
      : {};

  return { getTooltipProps, getBadgeProps, close };
};
